<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ modalTitle | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" (onClick)="onCancel()">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-y-auto">
  <div *ngIf="modalDescription" class="fl-alert fl-alert-info mb-4">
    <span>{{ modalDescription | translate }}</span>
  </div>

  <div
    *ngIf="data.statusAlert"
    class="fl-alert"
    [ngClass]="{
      'fl-alert-info': data.statusAlert.type === 'info',
      'fl-alert-success': data.statusAlert.type === 'success'
    }">
    <span>{{ data.statusAlert.label }}</span>
  </div>

  <form [formGroup]="form" class="flex flex-col gap-2 pt-4">
    <div *ngIf="data.showSeparatePdfs" class="flex flex-col gap-2 mb-2">
      <mat-checkbox class="w-full min-w-0" formControlName="createSeparateMediaPdfs" color="primary">
        <span class="flex whitespace-normal break-words">{{ 'campaign.sendouts.separateMediaPdfs' | translate }}</span>
      </mat-checkbox>
    </div>

    <div class="flex flex-col pt-2">
      <h4 class="mb-0 font-bold">
        {{ 'campaign.sendouts.emailRecipients' | translate }}
      </h4>
      <p *ngIf="data.recipientsDescription" class="text-xs text-gray-500 mt-1 mb-0">
        {{ data.recipientsDescription | translate }}
      </p>

      <flow-email-sendouts-list [emailRecipients]="emailRecipients" [isEditMode]="true"></flow-email-sendouts-list>

      <div *ngIf="invalidRecipients.length" class="fl-alert fl-alert-error mt-3 flex flex-col gap-1">
        <p class="text-sm font-semibold m-0">{{ 'campaign.sendouts.invalidRecipients' | translate }}</p>
        <span *ngFor="let email of invalidRecipients; trackBy: trackByIndex" class="text-sm">{{ email }}</span>
      </div>
    </div>
  </form>
</mat-dialog-content>
<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" (onClick)="onCancel()">
    {{ 'global.cancel' | translate }}
  </flow-button>
  <flow-button theme="primary" variation="fill" (onClick)="onSend()" [disabled]="form.invalid || isSending">
    {{ modalSubmitLabel | translate }}
  </flow-button>
</div>
